<div class="unsync-vehicle-dialog">
  <div class="unsync-vehicle-dialog-header flex-start-center">
    <p class="m-0 font-bold">Save vehicle {{motor?.name}}</p>
  </div>


  <div class="unsync-vehicle-dialog-body flex-column flex-wrap flex-start-start">
    <div class="flex-column width-100p" *ngIf="!isLoading">
      <div class=" width-100p">
        <span class="font-bold">{{motor?.name}}</span> was created using MOTOR. We found an alternate match from Carfax
        -
        <span class="font-bold">{{carfax?.name}}</span>.
      </div>

      <span>We recommend saving MOTOR vehicle.</span>
    </div>

    <div class="flex-start-center" *ngIf="isLoading">
      <span class="pr-2">Loading</span>
      <i class="fal fa-spinner rotate"></i>
    </div>
  </div>

  <div class="unsync-vehicle-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" [disabled]="isLoading || isProcessing"
      (click)="handleSaveOption('carfax')">
      Update (Carfax)
      <i class="fal fa-spinner rotate" *ngIf="isProcessing"></i>
    </button>

    <button class="btn btn-primary btn-submit" [disabled]="isLoading" (click)="handleSaveOption('motor')">
      Save (MOTOR)
    </button>
  </div>
</div>
